import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=291e900c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=291e900c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291e900c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291e900c')) {
      api.createRecord('291e900c', component.options)
    } else {
      api.reload('291e900c', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=291e900c&scoped=true", function () {
      api.rerender('291e900c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/Footer.vue"
export default component.exports